import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from "./store";
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import VueSession from 'vue-session';
import Hotjar from 'vue-hotjar';
import GoogleAuth from './assets/config/google_oAuth.js';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Constants from './assets/js/constants.js';
import VueAnalytics from 'vue-analytics';
import VueFacebookPixel from 'vue-analytics-facebook-pixel';

//Date-time-picker CSS
import 'vue2-datepicker/index.css';
// Form Validator
import SimpleVueValidation from 'simple-vue-validator';
var options = {
    persist: true
}
Vue.use(VueSession, options);
const gauthOption = {
    clientId: '788816236640-dd68pf0r4dnt7tm0na1fk4pji6iv34qm.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'select_account'
}
Vue.use(GoogleAuth, gauthOption);

Vue.use(BootstrapVue);
Vue.use(Constants);
Vue.use(SimpleVueValidation);
Vue.use(VueFacebookPixel);

// To use style.css in appliction
//require('@/assets/style.css')

Vue.config.productionTip = false;

if (store.state.store_url_name || window.location.href.includes('/home/') || window.location.href.includes('/service/')) {
    let api, store_url, ga_id, fb_id;
    if (window.location.hostname === 'localhost') {
        api = 'http://localhost:5643/';
    } else {
        api = window.location.protocol + '//' + window.location.host + '/bookjoy_v2/';
    }
    if (store.state.store_url_name) {
        store_url = store.state.store_url_name;
    } else if (window.location.href.includes('/home/')) {
        let get_main_url = window.location.href;
        get_main_url = get_main_url.substr(get_main_url.indexOf('/home'), get_main_url.length);
        get_main_url = get_main_url.split('/');
        store_url = get_main_url[2].replace(/%20/g, " ");
    } else if (window.location.href.includes('/service/')) {
        let get_main_url = window.location.href;
        get_main_url = get_main_url.substr(get_main_url.indexOf('/service'), get_main_url.length);
        get_main_url = get_main_url.split('/');
        store_url = get_main_url[3].replace(/%20/g, " ");
    }
    try {
        axios.post(`${api}v2/stores/get_store_details_v2`, {
            "store_url_name": store_url
        }).then(response => {
            if (response.data.status == 200) {
                if (response.data.result.stores_track_google_analytics) {
                    ga_id = response.data.result.stores_track_google_analytics;
                } else {
                    ga_id = '';
                }
                if (response.data.result.stores_track_facebookpixel) {
                    fb_id = response.data.result.stores_track_facebookpixel;
                } else {
                    fb_id = '';
                }
                Vue.use(VueAnalytics, {
                    id: ga_id,
                });
                Vue.analytics.fbq.init(fb_id);
            }
        }).catch((error) => {
            if (error.response) {
                console.log(error.response.data); // => the response payload 
            }
        });
    } catch (err) {
        console.log(err)
    }
}




if ((window.location.hostname == "bookjoy.co") || (window.location.hostname == "get.bookjoy.co")) {
    Vue.use(Hotjar, {
        id: "1245386",
        isProduction: true,
    })
}


new Vue({
    router,
    store,
    created() {
        if (window.location.hostname === 'localhost') {
            this.$store.commit('setUrl', 'http://localhost:5643/');
        } else {
            this.$store.commit('setUrl', window.location.protocol + '//' + window.location.host + '/bookjoy_v2/');
        }
    },
    render: h => h(App)
}).$mount('#app')
